import { towne as towneBase } from "@thirdparty/companies";

import { gtb } from "../gtb";
import { GtbCustomApp } from "../gtb/types";

export const towne: GtbCustomApp = {
  ...towneBase,
  routes: gtb.routes,
};
